var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "CardLoadable",
    _vm._b(
      { attrs: { "no-body": "" } },
      "CardLoadable",
      { loading: !!_vm.loading },
      false
    ),
    [
      _c(
        "b-card-body",
        [
          _c("b-card-title", [
            _c("div", { staticClass: "h6" }, [
              _c("span", { staticClass: "card-title" }, [
                _vm._v(_vm._s(_setup.title)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [_vm._t("header")], 2),
          ]),
          _vm._v(" "),
          _c(
            "b-container",
            [
              _c(
                "b-row",
                { staticClass: "license-usage-item" },
                [
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _c("div", { staticClass: "license-usage-item-label" }, [
                      _c("span", [_vm._v("Students")]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticStyle: { "padding-top": "4px" },
                      attrs: { cols: "7" },
                    },
                    [
                      _c("b-progress", {
                        attrs: {
                          value: _vm.usedStudentLicenses,
                          variant: _setup.studentLicenseVariant,
                          max: _vm.maxStudentLicenses,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { cols: "2" },
                    },
                    [
                      _c("div", { staticClass: "license-usage-item-total" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.usedStudentLicenses) +
                            "/" +
                            _vm._s(_vm.maxStudentLicenses) +
                            "\n          "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.maxInstructorLicenses &&
              _vm.usedInstructorLicenses !== undefined
                ? [
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "license-usage-item" },
                      [
                        _c("b-col", { attrs: { cols: "3" } }, [
                          _c(
                            "div",
                            { staticClass: "license-usage-item-label" },
                            [_c("span", [_vm._v("Instructors")])]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticStyle: { "padding-top": "4px" },
                            attrs: { cols: "7" },
                          },
                          [
                            _c("b-progress", {
                              attrs: {
                                value: _vm.usedInstructorLicenses,
                                variant: "info",
                                max: _vm.maxInstructorLicenses,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticStyle: { "text-align": "center" },
                            attrs: { cols: "2" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "license-usage-item-total" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.usedInstructorLicenses) +
                                    "/" +
                                    _vm._s(_vm.maxInstructorLicenses) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.maxAdminLicenses && _vm.usedAdminLicenses !== undefined
                ? [
                    _c(
                      "b-row",
                      { staticClass: "license-usage-item" },
                      [
                        _c("b-col", { attrs: { cols: "3" } }, [
                          _c(
                            "div",
                            { staticClass: "license-usage-item-label" },
                            [_c("span", [_vm._v("Admins")])]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticStyle: { "padding-top": "4px" },
                            attrs: { cols: "7" },
                          },
                          [
                            _c("b-progress", {
                              attrs: {
                                value: _vm.usedAdminLicenses,
                                variant: "info",
                                max: _vm.maxAdminLicenses,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticStyle: { "text-align": "center" },
                            attrs: { cols: "2" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "license-usage-item-total" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.usedAdminLicenses) +
                                    "/" +
                                    _vm._s(_vm.maxAdminLicenses) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card-footer",
        { staticClass: "footer-container" },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "outline-primary", size: "sm", pill: "" },
              on: { click: _setup.addMoreLicenses },
            },
            [_vm._v("\n      Need More Licenses?\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }